//	Externals
import React, { useEffect, useState } from "react";

//Internal
// import loadingImage from "../../public/assets/images/loader.svg";
// import loading1Image from "../../public/assets/images/circle-loader.gif";
// import loading2Image from "../../public/assets/images/circle-loader2.gif";
// import loading3Image from "../../public/assets/images/circle-loader3.gif";
import loading2Image from "../../public/assets/images/light-gray-loader3.gif";
import loading4Image from "../../public/assets/images/loaders5.gif";

/*******************
@Purpose : Used for content loader
@Parameter : {}
@Author : INIC
******************/
export const ContentLoader = ({ isVehicle }) => {
  const [isWeb, setIsWeb] = useState(true);

  const mystyle1 = {
    position: "fixed",
    top: 0,
    left: 0,
    height: "100vh",
    width: "100%",
    zIndex: 9999999,
  };

  useEffect(() => {
    if (window.screen.width < 768) {
      setIsWeb(false);
    } else {
      setIsWeb(true);
    }
  }, [isWeb]);



  /*******************
    @purpose : Rander HTML/ React Components
    @Author :INIC
    ******************/
  return (
    <div className="loader-wrap nprogress" style={mystyle1}>
      <div className="loader text-center">
        {isWeb ? (
          <img src={loading4Image} alt="Powered by Stripe" width="64" />
        ) : (
          <img src={loading2Image} alt="Powered by Stripe" width="32" />
        )}
      </div>
    </div>
  );
};
